import React from 'react'
import { TokenTransItem } from './TokenTransItem'
import { Transaction } from '../../../app/models/generated'
import styles from '../BlocksPage/index.module.sass'
interface TransactionArrayInterface {
    TransactionArray: Array<Transaction>
}

export const TokenTransItems = ({
    TransactionArray,
}: TransactionArrayInterface) => {
    return (
        <tbody className={styles.tableBody}>
            {TransactionArray.map((transaction: Transaction) => {
                return (
                    <TokenTransItem
                        key={transaction.hash}
                        transaction={transaction}
                    />
                )
            })}
        </tbody>
    )
}
